import get from 'lodash/get'

const createResponseCodesToErrorText = {
  403: `У Вас недостаточно прав для создания записи`,
}

const editResponseCodesToErrorText = {
  403: `У Вас недостаточно прав для изменения записи`,
}

const getFailMessage = (error, dictionary) => {
  const code = get(error, `code`)
  const message = get(dictionary, code)
  const exception = get(error, `exception`, `Запись не сохранена`)
  return message || exception
}

export const getCreateFailMessage = (error) => getFailMessage(error, createResponseCodesToErrorText)

export const getEditFailMessage = (error) => getFailMessage(error, editResponseCodesToErrorText)
